<app-sticky-header (close)="closeTermParagraph()" [show]="selectedTermParagraph !== undefined">
  <div header class="bg-helpBg flex flex-col p-4">
    <div class="flex flex-row">
      <span class="text-textHelp flex-1">{{ 'need_help' | translate }}</span>
      <img
        (click)="closeTermParagraph()"
        class="w-4 h-4 cursor-pointer"
        src="../../../../../../../assets/images/svg/cross-close.svg"
      />
    </div>
    <span class="mt-2 text-secondary font-bold text-lg">{{ selectedTermParagraph?.title }}</span>
  </div>
  <p main class="p-4 mt-2 text-xs md:text-sm whitespace-pre-wrap">{{ selectedTermParagraph?.consentText }}</p>
</app-sticky-header>

<app-sticky-header (close)="closeConditions()" [show]="isConditionsOpen">
  <div header class="bg-helpBg flex flex-col p-4">
    <div class="flex flex-row place-content-end">
      <img
        (click)="closeConditions()"
        class="w-4 h-4 cursor-pointer"
        src="../../../../../../../assets/images/svg/cross-close.svg"
      />
    </div>
    <span class="mt-2 text-secondary font-bold text-lg">{{ 'data_protection_help' | translate }}</span>
  </div>
  <p main class="p-4 mt-2 text-xs md:text-sm"><app-conditions></app-conditions></p>
</app-sticky-header>

<app-cancel-open-banking-popin
  (continue)="closeCancelPopin()"
  [show]="isCancelPopinOpen"
></app-cancel-open-banking-popin>

<div
  [class.h-full]="isCancelPopinOpen"
  [class.overflow-hidden]="isCancelPopinOpen"
  [class.max-lg:hidden]="isConditionsOpen || selectedTermParagraph !== undefined"
  class="flex flex-1 flex-col"
>
  <p class="text-sm font-bold text-secondary mb-5">{{ 'oney_need_bank_account_access' | translate }}</p>
  @for (consentTermParagraph of consentTermParagraphs; track consentTermParagraph; let i = $index) {
    <div>
      <span class="text-sm text-secondary">{{ consentTermParagraph.nonUnderlinedText + ' ' }} </span>
      <p
        (click)="openTermParagraph(i)"
        class="text-sm underline inline cursor-pointer text-secondary"
        [innerHTML]="consentTermParagraph.underlinedText"
      ></p>
    </div>
  }

  <div class="text-secondary bg-informationBg p-5 text-sm my-8 rounded-md">
    {{ 'open_banking_retrieves_automatically_data_from_your_bank_once_connected' | translate }}
  </div>

  <div class="text-secondary text-sm mb-5">
    {{ 'you_can_renounce_open_banking' | translate }}
  </div>

  <div class="text-secondary text-sm mb-5">
    <span class="text-sm text-secondary"
      >{{ 'you_can_consult_personal_data_protection_1' | translate }}
    </span>
    <p
      (click)="openConditions()"
      class="text-sm underline inline cursor-pointer text-secondary"
      [innerHTML]="'you_can_consult_personal_data_protection_2' | translate"
    ></p>
  </div>

  <button
    (click)="openCancelPopin()"
    class="text-secondary text-[10px] rounded-full border-primary border pr-2 pl-2 pb-1 pt-1 self-start min-[643px]:mb-10"
  >
    {{ 'continue_with_classic_form' | translate }}
  </button>
</div>

<app-sticky-footer
  [show]="selectedTermParagraph === undefined && isCancelPopinOpen === false && isConditionsOpen === false"
>
  <div class="flex">
    <input
      [ngClass]="{
        'border-error': shouldDisplayCheckboxMandatoryError,
        'border-gray-400': !shouldDisplayCheckboxMandatoryError
      }"
      (click)="onCheckboxClicked()"
      [(ngModel)]="isCheckboxConsentAccepted"
      [disabled]="shouldDisableCheckboxToggle"
      type="checkbox"
      class="mr-5 cursor-pointer inline-block align-top appearance-none w-[20px] min-w-[20px] h-[20px] min-h-[20px] mt-1 rounded-[4px] bg-white border border-gray-400 checked:bg-primary checked:border-primary checked:bg-[url('/assets/images/svg/validated-check-box.svg')] bg-no-repeat bg-center checked:bg-[length:14px_14px]"
    />

    <div class="flex flex-col">
      @if (shouldDisplayCheckboxMandatoryError) {
        <div class="flex flex-row mb-2">
          <span class="text-xs text-error mr-2">{{ 'checkbox_mandatory' | translate }}</span>
          <img class="w-4 h-4" src="../../../../../assets/images/svg/information_red.svg" />
        </div>
      }

      <span class="text-xs text-secondary"
        >{{ 'click_accept_means_you_know_conditions_1' | translate }}
        <span (click)="openCGU($event)" class="text-xs underline cursor-pointer text-secondary">{{
          'click_accept_means_you_know_conditions_2' | translate
        }}</span>
      </span>
    </div>
  </div>

  <button
    [ngClass]="{
      'bg-disabledButton': shouldDisableAcceptButton,
      'bg-primary': !shouldDisableAcceptButton
    }"
    [disabled]="shouldDisableAcceptButton"
    (click)="onAccepted()"
    [class.cursor-pointer]="!shouldDisableAcceptButton"
    class="flex flex-row items-center text-secondary font-bold text-base rounded-full pt-2 pb-2 mt-8 mb-2"
  >
    @if (shouldDisableAcceptButton) {
      <img class="size-7 absolute ml-3" src="../../../../../assets/svg/black-loader.svg" alt="loader" />
    }

    <div class="m-auto">{{ 'i_accept' | translate }}</div>
  </button>
</app-sticky-footer>
